import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { DGPackage } from 'src/app/utils/constants/strings';
import { FormGroup } from '@angular/forms';
interface ReferenceData {
  index: number;
  packageNo: number;
  packageWeight: number;
  contentId: string;
}
@Component({
  selector: 'app-dgpackages',
  templateUrl: './dgpackages.component.html',
  styleUrls: ['./dgpackages.component.css'],
})
export class DgpackagesComponent implements OnInit {
  @Input() value: any = [];
  @Input() DGType: any = '';
  @Output() valueChange = new EventEmitter<[]>();
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<ReferenceData>();
  displayedColumns = ['packageNo', 'packageWeight', 'action'];
  dgpackageType = DGPackage;
  constructor() {}

  ngOnInit(): void {
    if (this.DGType == this.dgpackageType.BiologicalSubstance) {
      this.displayedColumns = ['packageNo', 'action'];
    }

    if (this.value.length == 0) {
      this.value = [{ index: 0, packageNo: 0, packageWeight: 0, contentId: this.DGType }];
    }

    this.dataSource.data = this.value?.map((d: any, i: any) => {
      return {
        ...d,
        index: i,
      };
    });
  }

  updateForm(data) {}
  remove(dgPackage: ReferenceData): void {
    const index = this.dataSource.data.indexOf(dgPackage);
    console.log(index);
    if (index == 0) {
      this.value = [{ index: 0, packageNo: '', packageWeight: '' }];
      this.dataSource.data[0].packageNo = 0;
      this.dataSource.data[0].packageWeight = 0;
    } else if (index >= 0) {
      this.dataSource.data.splice(index, 1);
      this.dataSource.data = this.dataSource.data.map((d, i) => {
        return {
          ...d,
          index: i,
        };
      });
      this.dataSource._updateChangeSubscription();

      this.value = this.dataSource.data;
      this.valueChange.emit(this.value);
    }
  }
  Add(): void {
    let len = this.dataSource.data.length;
    this.dataSource.data.push({
      index: len,
      packageNo: 0,
      packageWeight: 0,
      contentId: this.DGType,
    });
    this.dataSource._updateChangeSubscription();
  }

  onKeyRelease() {
    this.value = this.dataSource.data;
    this.valueChange.emit(this.value);
  }
}
